import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ANNOUNCEMENTS } from "../nav/navigation";

const ROTATE_MS = 7000;

/**
 * Rotating announcement strip above the header. Rotation pauses on hover and
 * for anyone who has asked for reduced motion. Announcements are product news,
 * so the company home page does not carry them.
 */
export function AnnouncementBar() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")
      .matches;
    if (paused || reduced || ANNOUNCEMENTS.length < 2) return;
    const id = window.setInterval(
      () => setIndex((i) => (i + 1) % ANNOUNCEMENTS.length),
      ROTATE_MS,
    );
    return () => window.clearInterval(id);
  }, [paused]);

  const item = ANNOUNCEMENTS[index] ?? ANNOUNCEMENTS[0];
  if (!item || pathname === "/") return null;

  return (
    <div
      className="ann"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <Link to={item.href}>
        {item.text}
        <span aria-hidden="true"> →</span>
      </Link>
    </div>
  );
}
